import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"1vh"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute-full flex flex-center bg-negative text-white text-subtitle2" }, " No Image ", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }, " User Id ", -1)
const _hoisted_7 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }, " Company Name ", -1)
const _hoisted_10 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }, " First Name ", -1)
const _hoisted_13 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }, " Last Name ", -1)
const _hoisted_16 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }, " Email ", -1)
const _hoisted_19 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2 col-md-3 app__label--small text-right q-pa-sm" }, " Telefon ", -1)
const _hoisted_22 = { class: "col-sm-10 col-md-9 app__property--medium text-left q-pa-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_avatar, { size: "7rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_img, {
              src: _ctx.urlUserImgProfileByAppid,
              style: {"height":"7rem","max-width":"7rem"}
            }, {
              error: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["src"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.user.userid), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user.companyName), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.user.firstName), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.user.lastName), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.user.emailAddress), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.user.phoneNr), 1)
    ])
  ]))
}